const _ = window._; // TODO: Replace with import once all services are being imported instead of using window.cirkulServices
const $ = window.$; // TEMPORARY. REMOVE JQUERY WHEN POSSIBLE.

console.log('[2024-10-14] cart init');

// TODO: Remove IIFE, export hook that returns reactive cart state and callable functions.
// See https://kyleshevlin.com/use-encapsulation/
(() => {
    const ON_LOAD_SUCCESS_TOAST_LOCAL_VARIABLE = 'cirkul:on-load-success-toast';
    const HAS_SUBSCRIPTION_LOCAL_VARIABLE = 'cirkul:has-subscription';
    const DISCOUNTS = {
        tiers: [
            {
                tierNumber: 1,
                discount: 10,
                minimumSpend: 2500,
                tierAlertShown: false,
            },
            {
                tierNumber: 2,
                discount: 15,
                minimumSpend: 5000,
                tierAlertShown: false,
            },
            {
                tierNumber: 3,
                discount: 20,
                minimumSpend: 7500,
                tierAlertShown: false,
            },
            {
                tierNumber: 4,
                discount: 25,
                minimumSpend: 10000,
                tierAlertShown: false,
            },
        ],
        autoshipDiscount: 10,
        type: 'PCT',
    }
    const baseDiscountTier = {
        tierNumber: 0,
        discount: 0,
        minimumSpend: 0,
        tierAlertShown: true,
    };

    const NOT_COUNTABLE_PRODUCT_TYPES = [
        'Subscription Placeholder',
        'Standard Bundle Goods',
        'Subscription Goods'
    ];
    const NOT_DISCOUNTABLE_TITLES = [
        'Adam’s Super Starter Kit',
        'Cirkul Back Bundle',
        'Cirkul Back Bundle with Chill Sleeve',
        'Cirkul Starter Kit',
        'Starter Kit Holiday Gift',
        'Starter Kit Gift',
        'Best Sellers Bundle',
        'Wild Splash Kids Bundle',
        'Active Bundle',
        'Energy Bundle',
        'Family Bundle',
        'Limited Edition: 40oz. Brink All-Day StrawSip™ Tumbler', // Needed while FLVR LABs are temporarily discountable
        'Limited Edition: 40oz. Lilac All-Day StrawSip™ Tumbler', // Needed while FLVR LABs are temporarily discountable
        'Limited Edition: 40oz. Carbon All-Day StrawSip™ Tumbler', // Needed while FLVR LABs are temporarily discountable
        'Limited Edition: 40oz. Cherry Blossom All-Day StrawSip™ Tumbler', // Needed while FLVR LABs are temporarily discountable
        'Car Caddy',
        'CO₂ Cylinder',
        'Reward: CO₂ Cylinder',
        'Cirkul Plus™ Complete System',
        '32oz. Blush Pink Stainless Steel Bottle Starter Kit',
        '32oz. Chameleon Stainless Steel Bottle Starter Kit',
        '32oz. Matte Periwinkle Stainless Steel Bottle Starter Kit',
        '32oz. Hot Pink Stainless Steel Bottle Starter Kit',
        '32oz. Matte Black Stainless Steel Bottle Starter Kit',
        '32oz. Rose Gold Stainless Steel Bottle Starter Kit',
        '32oz. Plastic Bottle Starter Kit',
        '22oz. White Stainless Steel Bottle Starter Kit',
        '22oz. Plastic Bottle Starter Kit',
        '12oz. Plastic Bottle Starter Kit'
    ];
    const NOT_DISCOUNTABLE_PRODUCT_TYPES = [
        'Starter Kit Extras',
        'Limited Goods',
        'Subscription',
        'Gift Card',
        'Bundle',
    ];
    const NOT_DISCOUNTABLE_VENDORS = [
        'Cirkul Variety Packs',
    ];
    const FREE_GIFT_TRACKING_PROPERTY = '_free_gift_tracking';
    const FREE_GIFT_MINIMUM_CART_TOTAL_PROPERTY = '_free_gift_minimum_cart_total';
    const FREE_GIFT_MINIMUM_CART_FULL_PRICE_SIPS_COUNT_PROPERTY = '_free_gift_minimum_cart_full_price_sips_count';
    const STARTER_KIT_BUNDLE_PROPERTY = '_starter_kit_bundle';
    const OLD_STARTER_KIT_BUNDLE_PROPERTY = 'starter-kit-bundle';
    const GIFT_CARD_HELPER_VARIANT_ID = '40289418870874';
    const FREE_WHITE_BOTTLE_SKU = 'IMB22WHTLIDWHTBLUGSK';
    const FREE_22OZ_PLASTIC_BOTTLE_SKU = 'IPB22LIDWHTBLU';
    const FREE_12OZ_PLASTIC_BOTTLE_SKU = 'IPB12LIDWHTBLU';
    const BUNDLE_QUANTITY_MULTIPLIER_PROPERTY = '_bundle_quantity_multiplier';
    const OLD_BUNDLE_QUANTITY_MULTIPLIER_PROPERTY = 'bundle_quantity_multiplier'; // Can be removed after 2024-07-23

    // TODO: Do this via metafields instead of a hard-coded map
    const FULL_PRICE_TO_SUBSCRIPTION_GOODS_VARIANT_ID_MAP = {
        '40085925331034': '40099208298586', // 1PKFISBLUMGC -> S1PKFISBLUMGC
        '40085925363802': '40099208101978', // 1PKFISET -> S1PKFISET
        '40085925658714': '40099207938138', // 1PKFISFLRMAN -> S1PKFISFLRMAN
        '40085925691482': '40099207807066', // 1PKFISJCKPOT -> S1PKFISJCKPOT
        '40085925724250': '40099207577690', // 1PKFISNCT -> S1PKFISNCT
        '40254150967386': '40254171349082', // 1PKFISSHKBAK -> S1PKFISSHKBAK
        '40085926084698': '40099207381082', // 1PKFISSNDIT -> S1PKFISSNDIT
        '40251250573402': '40251250442330', // 1PKFITILPNCH -> S1PKFITILPNCH
        '31791120121946': '31781421449306', // 1PKFITLLST -> S1PKFITLLST
        '31791120154714': '31781421514842', // 1PKFITMB -> S1PKFITMB
        '31791120187482': '31781421711450', // 1PKFITOT -> S1PKFITOT
        '31791120220250': '31781421744218', // 1PKFITTRPBLS -> S1PKFITTRPBLS
        '31791120253018': '31781421809754', // 1PKFITWHTCHR -> S1PKFITWHTCHR
        '40206321090650': '40206321123418', // 1PKFLYFB -> S1PKFLYFB
        '40085935685722': '40099204628570', // 1PKFLYGL -> S1PKFLYGL
        '40268980453466': '40268980584538', // 1PKFLYHITSTK -> S1PKFLYHITSTK
        '40085936898138': '40099204563034', // 1PKFLYLO -> S1PKFLYLO
        '40085934964826': '40099204694106', // 1PKFLYLSTDRV -> S1PKFLYLSTDRV
        '40280882511962': '40280882610266', // 1PKFLYNOHIT -> S1PKFLYNOHIT
        '40085938045018': '40099204530266', // 1PKFLYOVT -> S1PKFLYOVT
        '40085939355738': '40099204431962', // 1PKFLYRF -> S1PKFLYRF
        '40085934112858': '40099204759642', // 1PKFLYRZ -> S1PKFLYRZ
        '40085940404314': '40099204333658', // 1PKFLYSO -> S1PKFLYSO
        '40300268388442': '40300268486746', // 1PKFLYWLKOFF -> S1PKFLYWLKOFF
        '40363915804762': '40363915903066', // 1PKFREFMNGDRG -> S1PKFREFMNGDRG
        '40363921801306': '40363921899610', // 1PKFREFPINK -> S1PKFREFPINK
        '40363887231066': '40363887329370', // 1PKFREFPRDSE -> S1PKFREFPRDSE
        '40085924216922': '40099209511002', // 1PKFRSTDCLS -> S1PKFRSTDCLS
        '40085924282458': '40190420877402', // 1PKFRSTDCREBRL -> S1PKFRSTDCREBRL
        '40085923922010': '40099209642074', // 1PKFRSTDCRM -> S1PKFRSTDCRM
        '40085924577370': '40251476738138', // 1PKFRSTDHZL -> S1PKFRSTDHZL
        '40085924806746': '40099209281626', // 1PKFRSTDMCH -> S1PKFRSTDMCH
        '40085924937818': '40154942603354', // 1PKFRSTDPMPSPC -> S1PKFRSTDPMPSPC
        '40206321811546': '40206321844314', // 1PKFRSTDPPRMCH -> S1PKFRSTDPPRMCH
        '40085925265498': '40099209117786', // 1PKFRSTDVNL -> S1PKFRSTDVNL
        '40276232798298': '40276232896602', // 1PKFRSTDWCRSP -> S1PKFRSTDWCRSP
        '31791120285786': '31781421842522', // 1PKGOBC -> S1PKGOBC
        '31791120351322': '31781421875290', // 1PKGOBLC -> S1PKGOBLC
        '40251248443482': '40251248050266', // 1PKGOBRSP -> S1PKGOBRSP
        '31791121563738': '31781421908058', // 1PKGOCHRLMD -> S1PKGOCHRLMD
        '31791123529818': '31781421973594', // 1PKGOCTRTWS -> S1PKGOCTRTWS
        '31791123660890': '31781422006362', // 1PKGOGRNAPP -> S1PKGOGRNAPP
        '31791123693658': '31781422039130', // 1PKGOGRP -> S1PKGOGRP
        '31791123726426': '31781422071898', // 1PKGOORG -> S1PKGOORG
        '31791123824730': '31781422104666', // 1PKGOSW -> S1PKGOSW
        '40085929984090': '40099205906522', // 1PKGWYGRNTEA -> S1PKGWYGRNTEA
        '40564427882586': '40564428046426', // 1PKGWYHNYGRN -> S1PKGWYHNYGRN
        '40085933228122': '40099205644378', // 1PKGWYSWTTEA -> S1PKGWYSWTTEA
        '40280877629530': '40280877760602', // 1PKGWYTEABLB -> S1PKGWYTEABLB
        '40268978552922': '40268978847834', // 1PKGWYTEABLC -> S1PKGWYTEABLC
        '40085932015706': '40099205808218', // 1PKGWYTEALEM -> S1PKGWYTEALEM
        '40300267929690': '40300268027994', // 1PKGWYTEAMNG -> S1PKGWYTEAMNG
        '40085927297114': '40099206135898', // 1PKGWYTEAPCH -> S1PKGWYTEAPCH
        '40085928640602': '40099206004826', // 1PKGWYTEARSP -> S1PKGWYTEARSP
        '40271092252762': '40271092351066', // 1PKINFBLC -> S1PKINFBLC
        '40271087108186': '40271087206490', // 1PKINFKWISTR -> S1PKINFKWISTR
        '40270866415706': '40271086420058', // 1PKINFPASDRG -> S1PKINFPASDRG
        '40271090548826': '40271090647130', // 1PKINFWHTCHR -> S1PKINFWHTCHR
        '40271088746586': '40271088648282', // 1PKINFWLDBRY -> S1PKINFWLDBRY
        '40271090942042': '40271091040346', // 1PKINFWTRMLN -> S1PKINFWTRMLN
        '31791123857498': '31781422170202', // 1PKLIFEBLBCRNST -> S1PKLIFEBLBCRNST
        '31791123890266': '31781422235738', // 1PKLIFEBPST -> S1PKLIFEBPST
        '31791124086874': '31781422268506', // 1PKLIFECP -> S1PKLIFECP
        '31791124152410': '31781422301274', // 1PKLIFEFP -> S1PKLIFEFP
        '40251249623130': '40251249590362', // 1PKLIFEHCA -> S1PKLIFEHCA
        '31791124185178': '31781422334042', // 1PKLIFELMNADE -> S1PKLIFELMNADE
        '31791124250714': '31781422727258', // 1PKLIFEMNGGRPST -> S1PKLIFEMNGGRPST
        '31791124283482': '31781422760026', // 1PKLIFEPCHMNG -> S1PKLIFEPCHMNG
        '31791124316250': '31781422792794', // 1PKLIFERL -> S1PKLIFERL
        '31791124349018': '31781422825562', // 1PKLIFEST -> S1PKLIFEST
        '31791124381786': '31781422858330', // 1PKLIFESTRKWI -> S1PKLIFESTRKWI
        '31791124414554': '31781422891098', // 1PKLIFESTRLMNST -> S1PKLIFESTRLMNST
        '31791124447322': '31781422923866', // 1PKLIFEWTRMLN -> S1PKLIFEWTRMLN
        '40085950103642': '40099199287386', // 1PKPRSNCAPP -> S1PKPRSNCAPP
        '40085950431322': '40099198697562', // 1PKPRSNCCUC -> S1PKPRSNCCUC
        '40349519904858': '40349521838170', // 1PKPRSNCLIM -> S1PKPRSNCLIM
        '40085949808730': '40099200729178', // 1PKPRSNCLMN -> S1PKPRSNCLMN
        '40085948268634': '40099202334810', // 1PKPRSNCPCH -> S1PKPRSNCPCH
        '40085950464090': '40099198566490', // 1PKPRSNCPER -> S1PKPRSNCPER
        '40085950496858': '40099198435418', // 1PKPRSNCPIN -> S1PKPRSNCPIN
        '40085949382746': '40099201876058', // 1PKPRSNCRSP -> S1PKPRSNCRSP
        '40276241776730': '40276241875034', // 1PKPRSNCSTR -> S1PKPRSNCSTR
        '40085948825690': '40099202138202', // 1PKPRSNCTNG -> S1PKPRSNCTNG
        '40293144625242': '40293144723546', // 1PKPRSNCWM -> S1PKPRSNCWM
        '40773360648282': '40773360746586', // 1PKPRSNCLILK -> S1PKPRSNCLILK
        '40291768336474': '40291768434778', // 1PKSABGUAVA -> S1PKSABGUAVA
        '40291767976026': '40291768139866', // 1PKSABHIBI -> S1PKSABHIBI
        '40300269338714': '40300269437018', // 1PKSABHRCHTA -> S1PKSABHRCHTA
        '40564493877338': '40564495810650', // 1PKSABPRKPER -> S1PKSABPRKPER
        '40291765485658': '40291765911642', // 1PKSABSOURSP -> S1PKSABSOURSP
        '40291755851866': '40291756081242', // 1PKSABSTR -> S1PKSABSTR
        '40668249227354': '40668249325658', // 1PKSABTAMRND -> S1PKSABTAMRND
        '40773364580442': '40773364678746', // 1PKSABPAPAYA -> S1PKSABPAPAYA
        '40085951053914': '40099185852506', // 1PKSQZBLBLEM -> S1PKSQZBLBLEM
        '40085950824538': '40099194568794', // 1PKSQZBLCLEM -> S1PKSQZBLCLEM
        '40276237942874': '40276238041178', // 1PKSQZGRPLEM -> S1PKSQZGRPLEM
        '40349397811290': '40349397975130', // 1PKSQZKWILEM -> S1PKSQZKWILEM
        '40085950529626': '40099196797018', // 1PKSQZLEM -> S1PKSQZLEM
        '40668204826714': '40668205875290', // 1PKSQZLYCLEM -> S1PKSQZLYCLEM
        '40085950988378': '40099190407258', // 1PKSQZORGLEM -> S1PKSQZORGLEM
        '40206321352794': '40206321385562', // 1PKSQZPNKLEM -> S1PKSQZPNKLEM
        '40085950693466': '40099195715674', // 1PKSQZRSPLEM -> S1PKSQZRSPLEM
        '40085950562394': '40099196207194', // 1PKSQZSTRLEM -> S1PKSQZSTRLEM
        '40293141053530': '40293141184602', // 1PKSQZTRPLEM -> S1PKSQZTRPLEM
        '40085951021146': '40099189522522', // 1PKSQZWMLEM -> S1PKSQZWMLEM
        '40085951414362': '40099181953114', // 1PKSTGBLCTWS -> S1PKSTGBLCTWS
        '40276243578970': '40276243677274', // 1PKSTGBRYBLND -> S1PKSTGBRYBLND
        '40085951447130': '40099181527130', // 1PKSTGLMNLME -> S1PKSTGLMNLME
        '40085951479898': '40099180839002', // 1PKSTGORG -> S1PKSTGORG
        '40085951512666': '40099179102298', // 1PKSTGSTRWTR -> S1PKSTGSTRWTR
        '40293148622938': '40293148721242', // 1PKSTGTRPNCH -> S1PKSTGTRPNCH
        '40300268781658': '40300268879962', // 1PKVERAPP -> S1PKVERAPP
        '40280884084826': '40280884183130', // 1PKVERCHR -> S1PKVERCHR
        '40085951578202': '40099177005146', // 1PKVERCLEM -> S1PKVERCLEM
        '40085951676506': '40099175628890', // 1PKVERCUCLIM -> S1PKVERCUCLIM
        '40268981633114': '40268981731418', // 1PKVERFRTMED -> S1PKVERFRTMED
        '40085951774810': '40099173531738', // 1PKVERGRPFRT -> S1PKVERGRPFRT
        '40268981141594': '40268981239898', // 1PKVERKWISTR -> S1PKVERKWISTR
        '40085951643738': '40099175759962', // 1PKVERLMN -> S1PKVERLMN
        '40564442333274': '40564442431578', // 1PKVERORGPIN -> S1PKVERORGPIN
        '40085951545434': '40099177332826', // 1PKVERSTR -> S1PKVERSTR
        '40085951610970': '40099176382554', // 1PKVERWM -> S1PKVERWM
        '40277894889562': '40278010462298', // 1PKWLDALGAPP -> S1PKWLDALGAPP
        '40278012133466': '40278012330074', // 1PKWLDBERBRY -> S1PKWLDBERBRY
        '40482455978074': '40482456076378', // 1PKWLDCHTCHR -> S1PKWLDCHTCHR
        '40278015737946': '40278015836250', // 1PKWLDGCKGRP -> S1PKWLDGCKGRP
        '40278017048666': '40278017212506', // 1PKWLDLIONLL -> S1PKWLDLIONLL
        '40482455158874': '40482455322714', // 1PKWLDORGORG -> S1PKWLDORGORG
        '40278018555994': '40278018654298', // 1PKWLDPRPNCH -> S1PKWLDPRPNCH
        '40278018850906': '40278018949210', // 1PKWLDSHKSTR -> S1PKWLDSHKSTR
        '40482450341978': '40482450440282', // 1PKWLDWALWTR -> S1PKWLDWALWTR
        '41040796844122': '41040797827162', // 1PKSABDRGFRT -> S1PKSABDRGFRT
        '41040834756698': '41040835051610', // 1PKSQZPASLEM -> S1PKSQZPASLEM
        '41126061047898': '41126062489690', // 1PKLIFEBLBGRP -> S1PKLIFEBLBGRP
        '41126272729178': '41126273024090', // 1PKFITBLCBRS -> S1PKFITBLCBRS
        '41126299533402': '41126299631706', // 1PKGOKWIBRY -> S1PKGOKWIBRY
        '41210625491034': '41210626867290', // 1PKINFTRPFSN -> S1PKINFTRPFSN
        '41268265975898': '41268266041434', // 1PKFREFDRGBLS -> S1PKFREFDRGBLS
        '41268272431194': '41268272955482', // 1PKFREFPINMNG -> S1PKFREFPINMNG
        '41268276396122': '41268276461658', // 1PKFREFBPACAI -> S1PKFREFBPACAI
        '41268281114714': '41268281180250', // 1PKFREFPCHPF -> S1PKFREFPCHPF
        '41268290912346': '41268291240026', // 1PKINFNEBULA -> S1PKINFNEBULA
        '41268294189146': '41268294254682', // 1PKGWYTEAPER -> S1PKGWYTEAPER
        '41483840225370': '41483840618586', // 1PKACELLL -> S1PKACELLL
        '41483874205786': '41483874238554', // 1PKACELWHTPCH -> S1PKACELWHTPCH
        '41483885772890': '41483885838426', // 1PKACELGRPFRT -> S1PKACELGRPFRT
        '41483894390874': '41483894423642', // 1PKACELBLBACI -> S1PKACELBLBACI
        '41519120679002': '41519120711770', // 1PKPLUSCKOLACLS -> S1PKPLUSCKOLACLS
        '41519149645914': '41519152824410', // 1PKPLUSTENFR -> S1PKPLUSTENFR
        '41519147679834': '41519147712602', // 1PKPLUSSALNRB -> S1PKPLUSSALNRB
        '41519154266202': '41519154298970', // 1PKPLUSPPARK -> S1PKPLUSPPARK
        '41519169699930': '41519169732698', // 1PKPLUSGNVSEL -> S1PKPLUSGNVSEL
        '41519148269658': '41519148302426', // 1PKPLUSALPRUSH -> S1PKPLUSALPRUSH
        '41519167897690': '41519167930458', // 1PKPLUSJUMPGRP -> S1PKPLUSJUMPGRP
        '41519165014106': '41519165046874', // 1PKPLUSJUMPORG -> S1PKPLUSJUMPORG
        '41670738378842': '41670835273818', // 1PKLIFESTR -> S1PKLIFESTR
        '41670912737370': '41670912835674', // 1PKLIFEPOG -> S1PKLIFEPOG
        '41670987284570': '41670988595290', // 1PKFITSTRBLS -> S1PKFITSTRBLS
        '41671145717850': '41671145816154', // 1PKFITSB -> S1PKFITSB
        '41671155581018': '41671155646554', // 1PKFITAPPMLN -> S1PKFITAPPMLN
        '41671172391002': '41671172751450', // 1PKGOSTRDRM -> S1PKGOSTRDRM
        '41671201980506': '41671202078810', // 1PKGOBBPNCH -> S1PKGOBBPNCH
        '41673859858522': '41673860186202', // 1PKGOPASDRG -> S1PKGOPASDRG
        '41806992212058': '41806992146522', // 1PKWLDTOUTWS -> S1PKWLDTOUTWS
    };

    const alreadySubscriber = localStorage.getItem(HAS_SUBSCRIPTION_LOCAL_VARIABLE) === 'true';
    const customerCo2Credits = $('[data-customer-co2-credits]').data('customer-co2-credits') || 0;
    let deferrableProductsByVariantId = {};
    let cartItems = {};
    let cartStep = 1;
    let selectedPlan;
    let alertMsg = '';
    let suppressAlerts = false;
    let ignoredBottleWarning = false;
    let oldPlanInCart = false;

    // CART TOTAL VARIABLES
    let itemCount = 0;
    let offerItemCount = 0;
    let cartSubtotal = 0; // Without discounts applied (pulled directly from cart.js)
    let cartFullPriceSipsCount = 0;
    let discountableSubtotal = 0;
    let discountTotal = 0; // Discount Amt in $ (calculated)
    let cartTotal = 0; // With discount applied (calculated)
    let cartPlanTotal = 0; // Price with selected plan
    let cartAutoshipTotal = 0; // Price of next autoship
    let subscriptionPresets;
    let subPlanPlaceholderProduct = null;
    let sub4PackPlaceholderProduct = null;
    let bottlesInCart = 0;
    let fullPriceSipsInCart = [];

    // TIERS VARIABLES
    const TIER_REACHED_CLASS = 'tier-reached';
    const NEXT_TIER_CLASS = 'next-tier';
    let currentTier = baseDiscountTier;
    let nextTier = DISCOUNTS.tiers[0];
    let amountToNextTier = 0;

    window.cirkulServices = window.cirkulServices || {};
    window.cirkulServices.cart = {
        firstRenderComplete: false,
        addToCart: addToCart,
        addToCartBulk: addToCartBulk,
        updateCartItem: updateCartItem,
        updateCartItemPromise: updateCartItemPromise,
        clearCart: clearCart,
        getCart: getCart,
        showCart: showCart,
        cartItems: cartItems,
        getCartItemsByVariantId: getCartItemsByVariantId,
        calculateDiscountableSubtotalForCheckout: calculateDiscountableSubtotalForCheckout,
        setCartAttributes: setCartAttributes,
        toggleSuppressAlerts: toggleSuppressAlerts,
        _setCheckoutGiftCard: _setCheckoutGiftCard,
    };
    // RUN EVERYTHING ON PAGE LOAD

    // WARNING: Only use the `giftcard` query parameter for promotional gift cards.
    // Including a full gift card code in a URL is not considered secure enough for gift cards that customers have purchased themselves (which should be treated like credit cards)
    const giftCardCode = getParameterByName('giftcard');
    if (giftCardCode) {
        Promise.resolve()
            .then(getCart)
            .then(() => renderCart(true))
            .then(() => _setCheckoutGiftCard(giftCardCode))
            .then(_getDeferrableProducts)
            ;
    } else {
        Promise.resolve()
            .then(getCart)
            .then(() => renderCart(true))
            .then(_getDeferrableProducts)
            ;
    }

    window.resolveCirkulServices.cart();


    function _getDeferrableProducts() {
        if (_.size(deferrableProductsByVariantId)) {
            return;
        }

        return new Promise((resolve, reject) => {
            $.get('/pages/api-deferrable-products').done((responseJson) => {
                const apiResponse = typeof responseJson === 'object' ? responseJson : JSON.parse(responseJson);

                deferrableProductsByVariantId = _.keyBy(apiResponse.deferrableProducts, 'variantId');

                resolve();
            }).fail(reject);
        });
    }


    // Only way we've found to set gift card code automatically is to use a cart permalink
    // BUT, permalinks completely replace the cart and don't allow for line item properties, so...
    // Get and store the current cart, then use a permalink with a special helper SKU, then clear that helper SKU and replace original cart contents.
    // Gift card code ends up being remembered, and we still have whatever the customer's cart was before.
    function _setCheckoutGiftCard(giftCardCode) {
        let rememberedCart = {};


        return Promise.resolve()
            .then(_rememberCurrentCart)
            .then(_setGiftCard)
            .then(_restoreCart)
            ;

        function _rememberCurrentCart() {
            return new Promise((resolve, reject) => {
                $.get('/cart.json').done((cartResponse) => {
                    rememberedCart = {
                        attributes: cartResponse.attributes,
                        items: _.map(cartResponse.items, (item) => {
                            return {
                                id: item.id,
                                quantity: item.quantity,
                                properties: item.properties,
                                selling_plan: item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : null,
                            };
                        }),
                    };

                    resolve();
                }).fail(reject);
            });
        }

        function _setGiftCard() {
            return new Promise((resolve, reject) => {
                $.get(`/cart/${GIFT_CARD_HELPER_VARIANT_ID}:1?discount=${giftCardCode}`)
                    .done(resolve)
                    .fail(reject)
                    ;
            });
        }

        function _restoreCart() {
            const replacementAttributes = rememberedCart.attributes;
            const replacementItems = rememberedCart.items;

            return Promise.resolve()
                .then(clearCart)
                .then(() => {
                    if (replacementAttributes && _.size(replacementAttributes) > 0) {
                        return setCartAttributes(replacementAttributes);
                    }
                }).then(() => {
                    if (replacementItems && _.size(replacementItems) > 0) {
                        return addToCartBulk(replacementItems, false, false);
                    }
                })
                ;
        }
    }

    function calculateDiscountableSubtotalForCheckout(checkoutItems) {
        let checkoutDiscountSubtotal = 0;

        _.forEach(checkoutItems, (checkoutItem) => {
            if (!_.includes(NOT_DISCOUNTABLE_TITLES, checkoutItem.product_title) && !_.includes(NOT_DISCOUNTABLE_PRODUCT_TYPES, checkoutItem.product_type) && !_.includes(NOT_DISCOUNTABLE_VENDORS, checkoutItem.vendor)) {
                checkoutDiscountSubtotal += (checkoutItem.price * checkoutItem.quantity);
            }
        });

        return checkoutDiscountSubtotal;
    }

    function isCartItemDiscountable(cartItem) {
        return !(_.includes(NOT_DISCOUNTABLE_TITLES, cartItem.product_title) || _.includes(NOT_DISCOUNTABLE_PRODUCT_TYPES, cartItem.product_type) || _.includes(NOT_DISCOUNTABLE_VENDORS, cartItem.vendor));
    }

    function addToCart(item, skipEventLog, toastOnReload, skipApplyFreeGifts) {
        // Sign all items added to cart, to detect carts not built by us.
        item.properties = item.properties || {};
        item.properties._added_from = item.properties._added_from || 'website';

        return new Promise((resolve, reject) => {
            return $.ajax({
                data: item,
                dataType: 'json',
                type: 'POST',
                url: '/cart/add.js',
                success: ((res) => {
                    console.log(`TJN`, item, res);

                    if (!skipEventLog) {
                        try {
                            const eventId = Date.now();

                            const ecomProps = {
                                'add': {
                                    'products': [{
                                        'name': res.product_title, // productName,
                                        'id': item.id, // productId,
                                        'sku': res.sku, // variantSku
                                        'price': res.price / 100, // price,
                                        'category': res.product_type, // category,
                                        'quantity': item.quantity // 1
                                    }]
                                }
                            };
                            window.waitForCirkulServices.analyticsTags.then(() => {
                                const AnalayticsTagsService = window.cirkulServices.analyticsTags;
                                AnalayticsTagsService.logEvent(AnalayticsTagsService.TAG_EVENTS.ADD_TO_CART, ecomProps, eventId);
                            });
                        } catch (e) {
                            console.log(`TJN - Cart Event/BI error`, e);
                        }
                    }


                    if (toastOnReload) {
                        alertMsg = '';
                        localStorage.setItem(ON_LOAD_SUCCESS_TOAST_LOCAL_VARIABLE, `Added to Cart`);
                    } else {
                        alertMsg = 'Added to Cart';
                    }

                    return getCart()
                        .then(renderCart)
                        .then(resolve);
                }),
                error: reject,
            }).done(() => {
                if (!skipApplyFreeGifts) applyFreeGiftsToCart();
            });
        });
    }

    function addToCartBulk(items, skipEventLog, toastOnReload, skipApplyFreeGifts) {
        const addingSubscriptionItems = !!_.find(items, (item) => {
            return item.selling_plan;
        })

        if (addingSubscriptionItems) {
            return Promise.resolve()
                .then(removeAllSubscriptionItems) // prevent stacking multiple subscriptions accidentally
                .then(_convert4PackPlaceholders) // temporarily required for checkout extensibility, until transformations can be done on items with selling plans
                .then(_addToCart)
                .then(() => {
                    if (!skipApplyFreeGifts) applyFreeGiftsToCart();
                });
        } else {
            return Promise.resolve()
                .then(_addToCart)
                .then(() => {
                    if (!skipApplyFreeGifts) applyFreeGiftsToCart();
                });
        }

        function _convert4PackPlaceholders() {
            return Promise.resolve()
                .then(_getDeferrableProducts)
                .then(() => {
                    _.forEach(items, (item) => {
                        const recurringVariantId = item.properties?._recurring_variant_id
                        const deferrableProduct = recurringVariantId ? deferrableProductsByVariantId[recurringVariantId] : null;
                        if (item.id === sub4PackPlaceholderProduct.variantId && deferrableProduct?.placeholderVariantId && deferrableProduct?.placeholderSellingPlan) {
                            item.id = deferrableProduct.placeholderVariantId;
                            item.selling_plan = deferrableProduct.placeholderSellingPlan;
                        }
                    });
                });
        }

        function _addToCart() {
            _.forEach(items, (item) => {
                // Sign all items added to cart, to detect carts not built by us.
                item.properties = item.properties || {};
                item.properties._added_from = item.properties._added_from || 'website';
            });
            return new Promise((resolve, reject) => {
                return $.ajax({
                    data: {
                        items: items,
                    },
                    dataType: 'json',
                    type: 'POST',
                    url: '/cart/add.js',
                    // success: resolve,
                    success: ((res) => {
                        console.log(`TJN addToCartBulk res`, res);
                        console.log(`TJN items`, items);

                        if (!skipEventLog) {
                            const eventId = Date.now();

                            try {
                                const ecomProps = {
                                    'add': {
                                        'products': res.items.map((itm, idx) => {
                                            return {
                                                'name': itm.product_title, // productName,
                                                'id': itm.id, // productId,
                                                'sku': itm.sku, // variantSku
                                                'price': itm.price / 100, // price,
                                                'category': itm.product_type, // category,
                                                'quantity': items[idx].quantity, // 1
                                            };
                                        })
                                    }
                                };
                                window.waitForCirkulServices.analyticsTags.then(() => {
                                    const AnalayticsTagsService = window.cirkulServices.analyticsTags;
                                    AnalayticsTagsService.logEvent(AnalayticsTagsService.TAG_EVENTS.ADD_TO_CART, ecomProps, eventId);
                                });
                            } catch (e) {
                                console.log(`TJN - Cart Event/BI error`, e);
                            }
                        }

                        if (toastOnReload) {
                            alertMsg = '';
                            localStorage.setItem(ON_LOAD_SUCCESS_TOAST_LOCAL_VARIABLE, `Added to Cart`);
                        } else {
                            alertMsg = 'Added to Cart';
                        }

                        return getCart()
                            .then(renderCart)
                            .then(resolve);
                    }),
                    error: reject,
                })
            });
        }
    }

    function setCartAttributes(attributes) {
        return new Promise((resolve, reject) => {
            return $.ajax({
                data: {
                    attributes: attributes,
                },
                dataType: 'json',
                type: 'POST',
                url: '/cart/update.js',
                success: resolve,
                error: reject,
            });
        });
    }

    function toggleSuppressAlerts(shouldSuppressAlerts) {
        suppressAlerts = !!shouldSuppressAlerts;
    }

    function applyFreeGiftsToCart() {
        window.waitForCirkulServices.checkout.then(() => {
            window.cirkulServices.checkout.applyFreeGiftsToCart()
        });
    }

    // TO-DO: Move all update/remove actions here
    function updateCartItem(cirkulItemId, newQuantity, toastMessage, skipAlertMessage) {
        const newQuantityInt = parseInt(newQuantity);

        let updates = {};
        let bundleItemIds = getMatchingBundleItemIds(cirkulItemId);

        console.log(`bundleItemIds`, bundleItemIds);

        if (bundleItemIds) {
            for (const bundleItemId of bundleItemIds) {
                const updateKey = cartItems[bundleItemId].key;
                const quantityMultiplier = parseInt(cartItems[bundleItemId].properties[BUNDLE_QUANTITY_MULTIPLIER_PROPERTY] || cartItems[bundleItemId].properties[OLD_BUNDLE_QUANTITY_MULTIPLIER_PROPERTY] || 1);

                // update our cart
                if (newQuantityInt === 0) {
                    alertMsg = 'Product Removed';
                    delete cartItems[bundleItemId];
                } else {
                    // alertMsg = 'Product Updated';
                    cartItems[bundleItemId].quantity = newQuantityInt * quantityMultiplier;
                }

                // prep shopify cart/update.js update
                updates[updateKey] = newQuantityInt * quantityMultiplier;
            }
        }

        renderCart(); // render immediately using updated stuff, don't wait...

        if (_.size(updates) >= 1) {
            $.post('/cart/update.js', {
                updates: updates, // Object of: [variantId]: newQuantityInt
                // success: (() => {
                //     console.log("TJN SUCCESS!!!");
                //     applyFreeGiftsToCart();
                // })
            }, null, 'json').done(() => {
                alertMsg = toastMessage || alertMsg; // If we have a toastMessage, overwrite any other pending alertMsg.
                if (skipAlertMessage) alertMsg = null;
                applyFreeGiftsToCart();
            });
        } else {
            applyFreeGiftsToCart();
        }
    }

    function updateCartItemPromise(cirkulItemId, newQuantity, toastMessage, skipAlertMessage) {
        return new Promise((resolve, reject) => {
            const newQuantityInt = parseInt(newQuantity);

            let updates = {};
            let bundleItemIds = getMatchingBundleItemIds(cirkulItemId);

            console.log(`bundleItemIds`, bundleItemIds);

            if (bundleItemIds) {
                for (const bundleItemId of bundleItemIds) {
                    const updateKey = cartItems[bundleItemId].key;
                    const quantityMultiplier = parseInt(cartItems[bundleItemId].properties[BUNDLE_QUANTITY_MULTIPLIER_PROPERTY] || cartItems[bundleItemId].properties[OLD_BUNDLE_QUANTITY_MULTIPLIER_PROPERTY] || 1);

                    // update our cart
                    if (newQuantityInt === 0) {
                        alertMsg = skipAlertMessage ? null : 'Product Removed';
                        delete cartItems[bundleItemId];
                    } else {
                        // alertMsg = 'Product Updated';
                        cartItems[bundleItemId].quantity = newQuantityInt * quantityMultiplier;
                    }

                    // prep shopify cart/update.js update
                    updates[updateKey] = newQuantityInt * quantityMultiplier;
                }
            }

            renderCart(); // render immediately using updated stuff, don't wait...

            if (_.size(updates) >= 1) {
                $.post('/cart/update.js', {
                    updates: updates, // Object of: [variantId]: newQuantityInt
                    // success: (() => {
                    //     console.log("TJN SUCCESS!!!");
                    //     applyFreeGiftsToCart();
                    // })
                }, null, 'json').done(() => {
                    resolve();
                    alertMsg = toastMessage || alertMsg; // If we have a toastMessage, overwrite any other pending alertMsg.
                    applyFreeGiftsToCart();
                });
            } else {
                resolve();
                applyFreeGiftsToCart();
            }
        });
    }

    function clearCart() {
        // TO-DO: Move all clear cart actions here
        return new Promise((resolve, reject) => {
            $.get('/cart/clear.json').done(() => {
                resolve();
            }).fail(reject);
        });
    }

    function getCart() {
        return new Promise((resolve, reject) => {
            // NOTE: There's a weird incompatibility with using cart.js and then parsing resulting in an unexpected token ':' error, So we'll do this instead...
            $.get('/cart.json').done((cartResponse) => {
                let invalidItems = [];
                // don't destroy the cartItems object, so pointer references to it remain.
                // BUT: do destroy the previous object properties, so we don't accidentally hold on to old cart items
                // TODO: Determine why pointer references matter. Possibly refactor to not require?

                _.forEach(cartItems, (cartItem, key) => {
                    delete cartItems[key];
                });

                const lineItemsByGiftBundleKey = _.groupBy(cartResponse.items, 'properties._gift_bundle_id');
                for (const cartItem of cartResponse.items) {
                    /**
                     * Check for misconfigured bundles. 
                     * If properly configured, our Shopify Function merges them,
                     * so there should never be a Standard Bundle without components,
                     * or a Standard Bundle Goods item that's listed on its own.
                     * 
                     * Bundler function can currently hit instruction limit on large carts and fail to merge items,
                     * so if we find one of the above items that looks incorrect, do an additional manual check
                     * before actually deeming it invalid.
                     */
                    if (cartItem.product_type === 'Standard Bundle') {
                        if (cartItem.has_components) {
                            cartItems[getCirkulItemId(cartItem)] = cartItem;
                        } else {
                            const hasMatchingChildItems = _.filter(lineItemsByGiftBundleKey[cartItem.properties?._gift_bundle_id], { product_type: 'Standard Bundle Goods' }).length > 0;
                            if (hasMatchingChildItems) {
                                cartItems[getCirkulItemId(cartItem)] = cartItem;
                            } else {
                                invalidItems.push(cartItem);
                            }
                        }
                    } else if (cartItem.product_type === 'Standard Bundle Goods') {
                        const hasMatchingParentItem = _.filter(lineItemsByGiftBundleKey[cartItem.properties?._gift_bundle_id], { product_type: 'Standard Bundle' }).length === 1;
                        if (hasMatchingParentItem) {
                            cartItems[getCirkulItemId(cartItem)] = cartItem;
                        } else {
                            invalidItems.push(cartItem);
                        }
                    } else {
                        cartItems[getCirkulItemId(cartItem)] = cartItem;
                    }
                }

                // console.log("CARTRESPONSE", cartResponse);
                // console.log("CIRKUL_CART", cartItems);

                if (invalidItems.length) {
                    let itemsToRemove = _.reduce(invalidItems, (itemsToRemove, invalidItem) => {
                        itemsToRemove[invalidItem.key] = 0;
                        return itemsToRemove;
                    }, {});

                    $.ajax({
                        data: { updates: itemsToRemove },
                        dataType: 'json',
                        type: 'POST',
                        async: false,
                        url: '/cart/update.js',
                        success: resolve,
                        error: resolve, // Don't fail, just continue
                    });
                } else {
                    resolve();
                }
            });
        }).then(addTikTokClickId);
    }

    function showCart() {
        $('#sitewide-cart').foundation('open');
    }

    function getCartItemsByVariantId(variantIds) {
        return new Promise((resolve, reject) => {

            // Get fresh copy in case we've fallen out of sync (was seeing some cases where products were still in Shopify cart but not our copy)
            $.get('/cart.json').done((cartResponse) => {
                const resultCartItems = {};

                _.forEach(variantIds, (variantId) => {
                    const cartItemDetails = {
                        variantId: variantId,
                        quantity: 0,
                        propertiesByKey: {}
                    };
    
                    _.forEach(cartResponse.items, (cartItem) => {
                        if (cartItem.variant_id === variantId) {
                            cartItemDetails.quantity += cartItem.quantity;
                            cartItemDetails.propertiesByKey[cartItem.key] = cartItem.properties;
                        }
                    });
    
                    if (cartItemDetails.quantity > 0) {
                        resultCartItems[variantId] = cartItemDetails;
                    }
                });
    
                resolve(resultCartItems);

            }).fail(reject);
        });
    }

    function getSubscriptionPresets() {
        return new Promise((resolve, reject) => {
            $.get('/pages/api-free-trial-product', (response) => {
                const responseJSON = JSON.parse(response);
                subscriptionPresets = responseJSON.subscriptionPresets;
                // console.log(`TJN subscriptionPresets`, subscriptionPresets);
                subPlanPlaceholderProduct = responseJSON.planPlaceholderProduct;
                sub4PackPlaceholderProduct = responseJSON.planCartridgePlaceholderProduct;
                resolve();
            });
        });
    }

    function getParameterByName(name, url) {
        /* eslint-disable */
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
        /* eslint-enable */
    }

    function addSubscriptionItems() {
        return new Promise((resolve, reject) => {
            const selectedPlanDetails = subscriptionPresets[selectedPlan];
            const continuityPlanItems = __buildContinuityPlanItems();
            let planItems = [];

            if (continuityPlanItems.length > 0) {
                planItems.push(...continuityPlanItems);

                planItems.push({
                    id: subPlanPlaceholderProduct.variantId,
                    quantity: 1,
                    selling_plan: subPlanPlaceholderProduct.sellingPlan,
                    properties: {
                        'First Shipment In': `${selectedPlanDetails.trialPeriod} days`,
                        'Plan Size': selectedPlanDetails.title,
                        'Charge Per Shipment': `$${selectedPlanDetails.price}`,
                        '_plan_title': selectedPlanDetails.title,
                        '_plan_price': selectedPlanDetails.price,
                        '_recurring_variant_id': selectedPlanDetails.variantId,
                        '_subscription_preset_code': selectedPlanDetails.presetCode.replace('CART-A', 'CART-CONTINUITY'),
                        '_added_from': 'cart',
                    },
                });
            } else {
                // If we couldn't build our continuinity plan items above, fall back to previous method of using presets.
                _.forEach(selectedPlanDetails.subscriptionGoodsProducts, (subscriptionGoodsProduct) => {
                    planItems.push({
                        id: sub4PackPlaceholderProduct.variantId,
                        quantity: 1,
                        selling_plan: sub4PackPlaceholderProduct.sellingPlan,
                        properties: {
                            '_recurring_variant_id': subscriptionGoodsProduct.variantId,
                            '_added_from': 'cart',
                        },
                    });
                });

                planItems.push({
                    id: subPlanPlaceholderProduct.variantId,
                    quantity: 1,
                    selling_plan: subPlanPlaceholderProduct.sellingPlan,
                    properties: {
                        'First Shipment In': `${selectedPlanDetails.trialPeriod} days`,
                        'Plan Size': selectedPlanDetails.title,
                        'Charge Per Shipment': `$${selectedPlanDetails.price}`,
                        '_plan_title': selectedPlanDetails.title,
                        '_plan_price': selectedPlanDetails.price,
                        '_recurring_variant_id': selectedPlanDetails.variantId,
                        '_subscription_preset_code': selectedPlanDetails.presetCode,
                        '_added_from': 'cart',
                    },
                });
            }

            return addToCartBulk(planItems).then(resolve);

            function __buildContinuityPlanItems() {
                const fullPriceSipsTotalQuantity = _.sumBy(fullPriceSipsInCart, 'quantity');
                const planSipsQuantityRequired = parseInt(selectedPlanDetails.sipsQuantityRequired);
                const sortedProportionalFullPriceSips = _.chain(fullPriceSipsInCart)
                    .map((sip) => {
                        return {
                            ...sip,
                            proportion: sip.quantity / fullPriceSipsTotalQuantity,
                        }
                    }).sortBy('proportion')
                    .reverse() // descending proportionality
                    .value();
                let continuityPlanItems = [];

                _.forEach(sortedProportionalFullPriceSips, (fullPriceSip, index) => {
                    // Sips are sorted in descending proprortionality, so always add at least 1, 
                    // but don't use ceil to avoid overcompensating and leaving out some flavors
                    // e.g. in a case where there are 3 sips but a 4-pack subscription
                    const proportionalSipQuantity = Math.round(planSipsQuantityRequired * fullPriceSip.proportion) || 1;
                    const continuityPlanItemsTotalQuantity = _.sumBy(continuityPlanItems, 'quantity');
                    const remainingQuantityNeeded = planSipsQuantityRequired - continuityPlanItemsTotalQuantity;

                    if (remainingQuantityNeeded < 1) {
                        return;
                    }

                    continuityPlanItems.push({
                        id: sub4PackPlaceholderProduct.variantId,
                        quantity: Math.min(proportionalSipQuantity, remainingQuantityNeeded),
                        selling_plan: sub4PackPlaceholderProduct.sellingPlan,
                        properties: {
                            '_recurring_variant_id': fullPriceSip._recurring_variant_id,
                            '_added_from': 'cart',
                        },
                    });
                });

                const planSipsQuantityStillNeeded = planSipsQuantityRequired - _.sumBy(continuityPlanItems, 'quantity');
                if (planSipsQuantityStillNeeded > 0 && continuityPlanItems[0]) {
                    // If we didn't quite fill our required sips quantity, add more of the sip with the highest proportionality (ie. the one we added first)
                    continuityPlanItems[0].quantity += planSipsQuantityStillNeeded;
                } else if (planSipsQuantityStillNeeded < 0) {
                    // If we somehow over-filled continuityPlanItems, reset to an empty array, which will skip using continuity mode and fallback to preset flavors.
                    continuityPlanItems = [];
                }

                return continuityPlanItems;
            }
        });
    }

    function removeSubscriptionPlaceholderItems() {
        return new Promise((resolve, reject) => {
            let itemsToRemove = {};

            for (const cartKey of Object.keys(cartItems)) {
                if (cartKey.includes(subPlanPlaceholderProduct.variantId) || cartKey.includes(sub4PackPlaceholderProduct.variantId) || cartItems[cartKey].product_type === 'Subscription Placeholder') {
                    itemsToRemove[cartKey] = 0;
                }
            }

            // console.log(itemsToRemove);
            // alert(`removing ${Object.keys(itemsToRemove).length}`);

            if (_.size(itemsToRemove) < 1) {
                resolve();
                return;
            }

            return $.ajax({
                data: { updates: itemsToRemove },
                dataType: 'json',
                type: 'POST',
                async: false,
                url: '/cart/update.js',
                success: resolve,
                error: reject,
            });

        });
    }

    // For use when adding a subscription, to prevent stacking
    function removeAllSubscriptionItems() {
        return getCart().then(() => { // Ensure we have the latest cart
            return new Promise((resolve, reject) => {
                let itemsToRemove = _.chain(cartItems)
                    .pickBy((item) => {
                        let removeItem = false;

                        if (item.selling_plan_allocation) {
                            removeItem = true;
                        } else if (item.sku === 'SPB22LDWHBL') { // Free bottle SKU that comes with direct-to-subscription orders
                            removeItem = true;
                        }

                        return removeItem;
                    }) // filter down to just items with subscription-based properties
                    .mapValues(() => _.identity(0)) // set quantities to 0
                    .value()
                    ;

                //console.log(`MARCTEST removeAllSubscriptionItems`, itemsToRemove);
                //alert(`removing ${Object.keys(itemsToRemove).length}`);

                if (_.size(itemsToRemove) < 1) {
                    resolve();
                    return;
                }

                return $.ajax({
                    data: { updates: itemsToRemove },
                    dataType: 'json',
                    type: 'POST',
                    async: false,
                    url: '/cart/update.js',
                    success: resolve,
                    error: reject,
                });

            });
        })
    }

    // For use when removing a subscription plan.
    function removeAllSubscriptionAndTrialItems() {
        return getCart().then(() => { // Ensure we have the latest cart
            return new Promise((resolve, reject) => {
                let itemsToRemove = _.chain(cartItems)
                    .pickBy((item) => {
                        let removeItem = false;

                        if (item.selling_plan_allocation) {
                            removeItem = true;
                        } else if (item.properties && item.properties[STARTER_KIT_BUNDLE_PROPERTY]) {
                            removeItem = true;
                        } else if (item.properties && item.properties[OLD_STARTER_KIT_BUNDLE_PROPERTY]) {
                            // Remove non-private property check after 2024-07-23
                            removeItem = true;
                        } else if (item.product_type === 'Trial Kit' || item.product_type === 'Trial Goods' || item.product_type === 'Free Trial') {
                            removeItem = true;
                        } else if (item.product_type === 'Subscription Placeholder') {
                            removeItem = true;
                        } else if (item.product_type === 'Starter Kit Extras') {
                            removeItem = true;
                        } else if (item.sku === 'SPB22LDWHBL') { // Free bottle SKU that comes with direct-to-subscription orders
                            removeItem = true;
                        }

                        return removeItem;
                    })
                    .mapValues(() => _.identity(0)) // set quantities to 0
                    .value()
                    ;

                //console.log(`MARCTEST removeAllSubscriptionItems`, itemsToRemove);
                //alert(`removing ${Object.keys(itemsToRemove).length}`);

                if (_.size(itemsToRemove) < 1) {
                    resolve();
                    return;
                }

                return $.ajax({
                    data: { updates: itemsToRemove },
                    dataType: 'json',
                    type: 'POST',
                    async: false,
                    url: '/cart/update.js',
                    success: resolve,
                    error: reject,
                });

            });
        })
    }

    function updateCartTotals(firstRender = false) {
        recalculateCartSubtotal();
        recalculateItemCount();
        recalculateSpecialCartItems();

        currentTier = baseDiscountTier;

        // Calculate current discounts...
        for (const [i, tier] of DISCOUNTS.tiers.entries()) {
            // If the subtotal is at/above the tier, discount applies...
            if (discountableSubtotal >= tier.minimumSpend) {
                currentTier = DISCOUNTS.tiers[i];

                if (firstRender) {
                    currentTier.tierAlertShown = true; // do this to prevent showing alerts on decreases...
                }

                //  If there are still tiers, the next tier is one higher...
                if (i + 1 < DISCOUNTS.tiers.length) {
                    nextTier = DISCOUNTS.tiers[i + 1];
                } else {
                    nextTier = null;
                }
            }

            amountToNextTier = nextTier && nextTier.minimumSpend ? nextTier.minimumSpend - discountableSubtotal : 0;
        }

        // UPDATE THE TOTALS FOR STEP 1
        discountTotal = (discountableSubtotal * (currentTier.discount / 100));
        cartTotal = cartSubtotal - discountTotal;

        //localStorage.setItem('discountableSubtotal', discountableSubtotal); // Not needed anymore
    }

    // For bundled items, use a combo of the gift bundle id and the variant ID...
    function getCirkulItemId(item) {
        let itemId;
        if (item.properties && item.properties._gift_bundle_id) {
            itemId = item.properties._gift_bundle_id + ":" + item.id;
        } else if (item.properties && item.properties.gift_bundle_id) {
            // Remove non-private property check after 2024-07-23
            itemId = item.properties.gift_bundle_id + ":" + item.id;
        } else if (item.properties && (item.properties._recurring_variant_id || item.properties.recurring_variant_id || item.properties._customization || item.properties.customization || item.properties[FREE_GIFT_TRACKING_PROPERTY])) {
            // Remove non-private property checks after 2024-07-23
            itemId = item.key;
        } else if (item.properties && item.properties['free-lid-id']) {
            itemId = item.properties['free-lid-id'] + ":" + item.id;
        } else if (item.properties && item.properties['_free_lid_id']) {
            itemId = item.properties['_free_lid_id'] + ":" + item.id;
        } else if (item.vendor === 'Cirkul Variety Packs') { // Can have multiple line items for same products, discounted differently.
            itemId = item.key;
        } else {
            itemId = item.id;
        }
        return itemId;
    }

    // Also returns normal items if it's not a bundle...
    function getMatchingBundleItemIds(cirkulItemId) {
        const bundleId = cirkulItemId.toString().split(':')[0];
        if (bundleId) {
            const item = cartItems[cirkulItemId];

            if (item?.product_type && item.product_type === "Customizable Goods") {
                return [cirkulItemId]; // don't return multiple customizable items...
            } else if (item?.product_type && item.product_type === "Subscription") {
                return _.chain(cartItems).pickBy((item) => {
                    return _.includes(['Subscription', 'Subscription Goods'], item.product_type);
                }).keys().value(); // Remove all Subscription Goods alongside a Subscription
            } else {
                return Object.keys(cartItems).filter((id) => id.includes(bundleId));
            }
        }
    }

    function recalculateSpecialCartItems() {
        bottlesInCart = 0;
        fullPriceSipsInCart = [];

        for (const cartItem of Object.values(cartItems)) {
            if (cartItem.product_title && (
                _.toLower(cartItem.product_title).includes('bottle') || 
                _.toLower(cartItem.product_title).includes('tumbler') || 
                _.toLower(cartItem.product_title).includes('starter kit') || 
                _.toLower(cartItem.product_title).includes('cirkul back bundle') ||
                cartItem.sku?.includes('BUND-HOLIDAY') ||
                cartItem.sku?.includes('BUND-EVERGREEN')
            )) {
                bottlesInCart++;
            }

            if (cartItem.product_type === 'Subscription') {
                oldPlanInCart = true;
            }

            // TODO: Base this on a product metafield instead, which will link the Goods product directly to its Subscription Goods variant
            if (cartItem.product_type === 'Goods' && _.startsWith(cartItem.sku, '1PK')) {
                const recurringVariantId = FULL_PRICE_TO_SUBSCRIPTION_GOODS_VARIANT_ID_MAP[cartItem.variant_id];

                // Only add to collection if we found a recurring variant ID, to help prevent invalid subscriptions from being set up.
                if (recurringVariantId) {
                    fullPriceSipsInCart.push({
                        key: cartItem.key,
                        quantity: cartItem.quantity,
                        _recurring_variant_id: recurringVariantId,
                    });
                }
            }
        }
    }

    function recalculateCartSubtotal() {
        let cartHasFreeBottle = false;
        cartSubtotal = 0;
        cartFullPriceSipsCount = 0;
        discountableSubtotal = 0;

        for (const cartItem of Object.values(cartItems)) {
            cartSubtotal += (cartItem.price * cartItem.quantity);

            if (!_.includes(NOT_DISCOUNTABLE_TITLES, cartItem.product_title) && !_.includes(NOT_DISCOUNTABLE_PRODUCT_TYPES, cartItem.product_type) && !_.includes(NOT_DISCOUNTABLE_VENDORS, cartItem.vendor)) {
                // console.log("ELIGIBLE FOR DISCOUNT", cartItem.product_title);
                discountableSubtotal += (cartItem.price * cartItem.quantity);
            }

            if (cartItem.sku === FREE_WHITE_BOTTLE_SKU || cartItem.sku === FREE_22OZ_PLASTIC_BOTTLE_SKU || cartItem.sku === FREE_12OZ_PLASTIC_BOTTLE_SKU) {
                cartHasFreeBottle = true;
            }

            if (_.startsWith(cartItem.sku, '1PK')) {
                cartFullPriceSipsCount += cartItem.quantity;
            }
        }

        if (cartSubtotal >= 1500 && localStorage.getItem('freeSipAlert') != 'shown' && !!localStorage.getItem('newsletterFreeSipSku')) {
            window.toastr.success("Free Sip Unlocked!", null, { positionClass: 'toast-top-center' });
            localStorage.setItem('freeSipAlert', 'shown');
        }

        if (cartSubtotal >= 3500 && localStorage.getItem('freeBottleAlert') != 'shown' && cartHasFreeBottle) {
            window.toastr.success("Free Bottle and Lid Unlocked!", null, { positionClass: 'toast-top-center' });
            localStorage.setItem('freeBottleAlert', 'shown');
        }
    }

    function recalculateItemCount() {
        itemCount = 0;
        offerItemCount = 0;

        for (const cartItem of Object.values(cartItems)) {
            if (!_.includes(NOT_COUNTABLE_PRODUCT_TYPES, cartItem.product_type)) {
                // console.log('MARCTEST COUNTING CART ITEM', cartItem, cartItem.quantity, itemCount);
                if (cartItem.properties && (cartItem.properties._gift_bundle_id || cartItem.properties.gift_bundle_id)) {
                    // Remove non-private property checks after 2024-07-23
                    if (cartItem.properties._bundle_final_image_url || cartItem.properties.bundle_final_image_url) {
                        itemCount += cartItem.quantity;
                    }
                } else if (cartItem.properties && (cartItem.properties['_free_lid_id'] || cartItem.properties['free-lid-id'])) {
                    // Remove non-private property checks after 2024-07-23
                    if (cartItem.properties._bundle_variant_details || cartItem.properties.bundle_variant_details) {
                        itemCount += cartItem.quantity;
                    }
                } else {
                    itemCount += cartItem.quantity;
                }

                if (cartItem.properties && (cartItem.properties[FREE_GIFT_MINIMUM_CART_TOTAL_PROPERTY] || cartItem.properties[FREE_GIFT_MINIMUM_CART_FULL_PRICE_SIPS_COUNT_PROPERTY])) {
                    offerItemCount += cartItem.quantity;
                }
            }
        }

        // Don't allow subscription placeholder items if there are no normal products in cart...
        if (itemCount <= offerItemCount) {
            removeSubscriptionPlaceholderItems();
        }
    }

    // Show cart on pageload if url variable present
    if (getParameterByName('showCart') === 'true') {
        $('#sitewide-cart').foundation('open');
    }

    // Display the cart
    function renderCart(firstRender = false) {
        console.log("\n\nRENDER CART - DECLARATION BEFORE\n\n");
        return new Promise((resolve, reject) => {
            getSubscriptionPresets()
                .then(() => updateCartTotals(firstRender))
                .then(() => {
                    if (firstRender) {
                        return applyFreeGiftsToCart();
                    }
                })
                .then(_convertRewardsCo2Tanks)
                .then(_renderCartItems)
                .then(_renderCartTotals)
                .then(_renderTierDiscounts)
                .then(_renderTierDiscountMessage)
                .then(_renderAlerts)
                .then(_syncOnPageQuantityControls)
                .then(_syncModalSipsInCartCounts)
                .then(() => {
                    window.cirkulServices.cart.firstRenderComplete = true;
                    $(window).trigger('cirkul:cart:render', JSON.stringify(cartItems));
                })
                .catch((err) => console.log('service-cart.js - renderCart Chain ERROR', err));

            resolve();
        });

        function _convertRewardsCo2Tanks() {
            // TODO: Retrieve these variant IDs dynamically instead of hard-coding (from helper div / as props)
            const FULL_PRICE_CO2_CYLINDER_1_PACK_VARIANT_ID = '41519051898970';
            const FULL_PRICE_CO2_CYLINDER_2_PACK_VARIANT_ID = '41519051931738';
            const REWARDS_CO2_CYLINDER_1_PACK_VARIANT_ID = '41519055994970';
            const REWARDS_CO2_CYLINDER_2_PACK_1_CREDIT_VARIANT_ID = '41519056027738';
            const REWARDS_CO2_CYLINDER_2_PACK_2_CREDITS_VARIANT_ID = '41519056060506';
            let fullPriceCo2Cylinder1Packs = 0;
            let fullPriceCo2Cylinder1PacksKey = null;
            let fullPriceCo2Cylinder2Packs = 0;
            let fullPriceCo2Cylinder2PacksKey = null;
            let rewardsCo2Cylinder1Packs = 0;
            let rewardsCo2Cylinder1PacksKey = null;
            let rewardsCo2Cylinder2Packs1Credit = 0;
            let rewardsCo2Cylinder2Packs1CreditKey = null;
            let rewardsCo2Cylinder2Packs2Credits = 0;
            let rewardsCo2Cylinder2Packs2CreditsKey = null;
            let totalCreditsInUse = 0;
            let totalCreditsAvailable = 0;
            let productsToUpdateByKey = {};
            let productsToAddByVariantId = {};

            // Intentionally does not return this promise. Will trigger another re-render when done with any cart updates.
            Promise.resolve()
                .then(__buildInitialCounts)
                .then(__prepareCartUpdates)
                .then(__applyCartUpdates)
            ;

            function __buildInitialCounts() {
                // Build total number of CO2 Cylinder-related SKUs 
                for (const cartItem of Object.values(cartItems)) {
                    if (cartItem.sku === '1FULL_CYLVAL630-US') {
                        fullPriceCo2Cylinder1Packs += cartItem.quantity;
                        fullPriceCo2Cylinder1PacksKey = cartItem.key;
                    } else if (cartItem.sku === '2FULL_CYLVAL630-US') {
                        fullPriceCo2Cylinder2Packs += cartItem.quantity;
                        fullPriceCo2Cylinder2PacksKey = cartItem.key;
                    } else if (cartItem.sku === 'R1C1FULL_CYLVAL630-US') {
                        rewardsCo2Cylinder1Packs += cartItem.quantity;
                        rewardsCo2Cylinder1PacksKey = cartItem.key;
                    } else if (cartItem.sku === 'R2C1FULL_CYLVAL630-US') {
                        rewardsCo2Cylinder2Packs1Credit += cartItem.quantity;
                        rewardsCo2Cylinder2Packs1CreditKey = cartItem.key;
                    } else if (cartItem.sku === 'R2C2FULL_CYLVAL630-US') {
                        rewardsCo2Cylinder2Packs2Credits += cartItem.quantity;
                        rewardsCo2Cylinder2Packs2CreditsKey = cartItem.key;
                    }
                }

                // Determine any conversions that need to be made
                totalCreditsInUse = (
                    (rewardsCo2Cylinder1Packs * 1) + 
                    (rewardsCo2Cylinder2Packs1Credit * 1) + 
                    (rewardsCo2Cylinder2Packs2Credits * 2)
                );
                totalCreditsAvailable = customerCo2Credits - totalCreditsInUse;
            }

            function __prepareCartUpdates() {
                // Convert non-reward SKUs to reward SKUs as able
                while (totalCreditsAvailable > 0 && (fullPriceCo2Cylinder1Packs || fullPriceCo2Cylinder2Packs)) {
                    // Prioritize converting 1-packs, then 2-packs with 2 credits, then 2-packs with 1 credit.
                    if (fullPriceCo2Cylinder1Packs) {
                        fullPriceCo2Cylinder1Packs -= 1;
                        rewardsCo2Cylinder1Packs += 1;
                        totalCreditsInUse += 1;
                        totalCreditsAvailable -= 1;

                        productsToAddByVariantId[REWARDS_CO2_CYLINDER_1_PACK_VARIANT_ID] = productsToAddByVariantId[REWARDS_CO2_CYLINDER_1_PACK_VARIANT_ID] || 
                                { id: REWARDS_CO2_CYLINDER_1_PACK_VARIANT_ID, quantity: 0, properties: { _added_from: 'website' } }
                        ;
                        productsToAddByVariantId[REWARDS_CO2_CYLINDER_1_PACK_VARIANT_ID].quantity += 1;

                        productsToUpdateByKey[fullPriceCo2Cylinder1PacksKey] = fullPriceCo2Cylinder1Packs;
                    } else if (fullPriceCo2Cylinder2Packs && totalCreditsAvailable > 1) {
                        fullPriceCo2Cylinder2Packs -= 1;
                        rewardsCo2Cylinder2Packs2Credits += 1;
                        totalCreditsInUse += 2;
                        totalCreditsAvailable -= 2;
                        
                        productsToAddByVariantId[REWARDS_CO2_CYLINDER_2_PACK_2_CREDITS_VARIANT_ID] = productsToAddByVariantId[REWARDS_CO2_CYLINDER_2_PACK_2_CREDITS_VARIANT_ID] || 
                                { id: REWARDS_CO2_CYLINDER_2_PACK_2_CREDITS_VARIANT_ID, quantity: 0, properties: { _added_from: 'website' } }
                        ;
                        productsToAddByVariantId[REWARDS_CO2_CYLINDER_2_PACK_2_CREDITS_VARIANT_ID].quantity += 1;

                        productsToUpdateByKey[fullPriceCo2Cylinder2PacksKey] = fullPriceCo2Cylinder2Packs;
                    } else if (fullPriceCo2Cylinder2Packs & totalCreditsAvailable === 1) {
                        fullPriceCo2Cylinder2Packs -= 1;
                        rewardsCo2Cylinder2Packs1Credit += 1;
                        totalCreditsInUse += 1;
                        totalCreditsAvailable -= 1;
                        
                        productsToAddByVariantId[REWARDS_CO2_CYLINDER_2_PACK_1_CREDIT_VARIANT_ID] = productsToAddByVariantId[REWARDS_CO2_CYLINDER_2_PACK_1_CREDIT_VARIANT_ID] || 
                                { id: REWARDS_CO2_CYLINDER_2_PACK_1_CREDIT_VARIANT_ID, quantity: 0, properties: { _added_from: 'website' } }
                        ;
                        productsToAddByVariantId[REWARDS_CO2_CYLINDER_2_PACK_1_CREDIT_VARIANT_ID].quantity += 1;

                        productsToUpdateByKey[fullPriceCo2Cylinder2PacksKey] = fullPriceCo2Cylinder2Packs;
                    }
                }

                // Convert reward SKUs to non-reward SKUs as needed
                while (totalCreditsAvailable < 0 && (rewardsCo2Cylinder1Packs || rewardsCo2Cylinder2Packs1Credit || rewardsCo2Cylinder2Packs2Credits)) {
                    // Prioritize converting 2-packs with 2 credits, then 2-packs with 1 credit, then 1-packs.
                    if (rewardsCo2Cylinder2Packs2Credits && totalCreditsAvailable < -1) {
                        rewardsCo2Cylinder2Packs2Credits -= 1;
                        fullPriceCo2Cylinder2Packs += 1;
                        totalCreditsInUse -= 2;
                        totalCreditsAvailable += 2;

                        productsToAddByVariantId[FULL_PRICE_CO2_CYLINDER_2_PACK_VARIANT_ID] = productsToAddByVariantId[FULL_PRICE_CO2_CYLINDER_2_PACK_VARIANT_ID] || 
                                { id: FULL_PRICE_CO2_CYLINDER_2_PACK_VARIANT_ID, quantity: 0, properties: { _added_from: 'website' } }
                        ;
                        productsToAddByVariantId[FULL_PRICE_CO2_CYLINDER_2_PACK_VARIANT_ID].quantity += 1;

                        productsToUpdateByKey[rewardsCo2Cylinder2Packs2CreditsKey] = rewardsCo2Cylinder2Packs2Credits;
                    } else if (rewardsCo2Cylinder2Packs1Credit) {
                        rewardsCo2Cylinder2Packs1Credit -= 1;
                        fullPriceCo2Cylinder2Packs += 1;
                        totalCreditsInUse -= 1;
                        totalCreditsAvailable += 1;
                        
                        productsToAddByVariantId[FULL_PRICE_CO2_CYLINDER_2_PACK_VARIANT_ID] = productsToAddByVariantId[FULL_PRICE_CO2_CYLINDER_2_PACK_VARIANT_ID] || 
                                { id: FULL_PRICE_CO2_CYLINDER_2_PACK_VARIANT_ID, quantity: 0, properties: { _added_from: 'website' } }
                        ;
                        productsToAddByVariantId[FULL_PRICE_CO2_CYLINDER_2_PACK_VARIANT_ID].quantity += 1;

                        productsToUpdateByKey[rewardsCo2Cylinder2Packs1CreditKey] = rewardsCo2Cylinder2Packs1Credit;
                    } else if (rewardsCo2Cylinder1Packs) {
                        rewardsCo2Cylinder1Packs -= 1;
                        fullPriceCo2Cylinder1Packs += 1;
                        totalCreditsInUse -= 1;
                        totalCreditsAvailable += 1;
                        
                        productsToAddByVariantId[FULL_PRICE_CO2_CYLINDER_1_PACK_VARIANT_ID] = productsToAddByVariantId[FULL_PRICE_CO2_CYLINDER_1_PACK_VARIANT_ID] || 
                                { id: FULL_PRICE_CO2_CYLINDER_1_PACK_VARIANT_ID, quantity: 0, properties: { _added_from: 'website' } }
                        ;
                        productsToAddByVariantId[FULL_PRICE_CO2_CYLINDER_1_PACK_VARIANT_ID].quantity += 1;

                        productsToUpdateByKey[rewardsCo2Cylinder1PacksKey] = rewardsCo2Cylinder1Packs;
                    }
                }
            }

            function __applyCartUpdates() {
                let appliedUpdates = false;

                return Promise.resolve()
                    .then(__updateExistingCartItems)
                    .then(__addCartItems)
                    .then(__reRenderCart)
                ;

                function __updateExistingCartItems() {
                    if (!_.size(productsToUpdateByKey)) return;

                    return new Promise((resolve, reject) => {
                        $.ajax({
                            data: {
                                updates: productsToUpdateByKey,
                            },
                            dataType: 'json',
                            type: 'POST',
                            url: '/cart/update.js',
                            success: () => {
                                appliedUpdates = true;
                                resolve();
                            },
                            error: reject,
                        });
                    });
                }

                function __addCartItems() {
                    if (!_.size(productsToAddByVariantId)) return;

                    const productsToAdd = _.values(productsToAddByVariantId);
                    return new Promise((resolve, reject) => {
                        $.ajax({
                            data: {
                                items: productsToAdd,
                            },
                            dataType: 'json',
                            type: 'POST',
                            url: '/cart/add.js',
                            success: () => {
                                appliedUpdates = true;
                                resolve();
                            },
                            error: reject,
                        });
                    });
                }

                function __reRenderCart() {
                    if (!appliedUpdates) return;

                    return getCart()
                        .then(renderCart)
                    ;
                }
            }
        }

        function _renderCartItems() {
            const $itemsContainer = $('[data-cart-items]');
            // Handle Adds and Updates
            for (const cartItem of Object.values(cartItems)) {
                const isRewardItem = cartItem.product_title.includes(`Reward:`);
                const isCXItem = cartItem.product_title.includes(`CX:`) || cartItem.product_type === "Bundle - Gift With Purchase";
                const isCirkulBackBundle = cartItem.product_title.includes('Cirkul Back Bundle');
                const isBogoBottleDrop = cartItem.sku == "BUND-JUL2025DROPSBOGO";
                const isPlanPageBottle = cartItem.sku === "SPB22LDWHBL";
                const isFreeBottle = cartItem.sku === FREE_WHITE_BOTTLE_SKU || cartItem.sku === FREE_22OZ_PLASTIC_BOTTLE_SKU || cartItem.sku === FREE_12OZ_PLASTIC_BOTTLE_SKU;
                const isPlan = cartItem.product_type === "Subscription";
                const isTrialKit = cartItem.product_type === "Trial Kit" || cartItem.product_type === "Trial Goods";
                const isLimitedItem = cartItem.product_type === 'Limited Goods' || _.startsWith(cartItem.sku, '1PKPLUS') || cartItem.sku === 'CKT116B018C01-US' || cartItem.sku === 'SKADAMSB';
                const limitedItemMax = (_.startsWith(cartItem.sku, 'LIM1PK') || _.startsWith(cartItem.sku, '1PKPLUS')) ? 10 :
                        cartItem.sku === 'CKT116B018C01-US' || cartItem.sku === 'SKADAMSB' ? 1 :
                        2
                ;

                const $cartItem = $(`[data-cart-item="${getCirkulItemId(cartItem)}"]`);
                if ($cartItem.length) {

                    const currentQtyDisplay = parseInt($cartItem.find('[data-cart-item-quantity-input]').val());

                    // Check current value before updating, to avoid infinite loop...
                    if (currentQtyDisplay !== cartItem.quantity) {
                        $cartItem.find('[data-cart-item-quantity-input]').val(cartItem.quantity);
                    }
                    // Always update the price
                    $cartItem.find('[data-cart-item-price-container]').html(`
                        <div data-cart-item-price-container>
                            ${isCartItemDiscountable(cartItem) ? `<div class="cart-item-price" data-cart-item-price="${getCirkulItemId(cartItem)}">$${(cartItem.quantity * cartItem.price * ((100 - currentTier.discount) / 100) / 100).toFixed(2)}</div>` : `<div class="cart-item-price" data-cart-item-price="${getCirkulItemId(cartItem)}">$${(cartItem.quantity * cartItem.price / 100).toFixed(2)}</div>`}
                            ${(currentTier.discount > 0 && isCartItemDiscountable(cartItem)) ? `<div class="cart-item-price strikethrough" data-cart-item-price="${getCirkulItemId(cartItem)}">$${(cartItem.quantity * cartItem.price / 100).toFixed(2)}</div>` : ''}
                        </div>
                    `);
                } else if (cartItem.product_title.includes('Bundle:') || cartItem.product_title.includes('Placeholder') || cartItem.product_title.includes('Auto-Ship Plan') || cartItem.product_title.includes('Starter Kit Extra: FREE') || cartItem.product_type === 'Subscription Goods') {
                    // If it's a placeholder or bundled item, or a subscription item, don't show it...
                    // console.log("Skipping Item", cartItem);
                } else {
                    let imgUrl;
                    if (cartItem.properties && cartItem.properties._bundle_final_image_url) {
                        imgUrl = cartItem.properties._bundle_final_image_url;
                    } else if (cartItem.properties && cartItem.properties.bundle_final_image_url) {
                        // Remove non-private property check after 2024-07-23
                        imgUrl = cartItem.properties.bundle_final_image_url;
                    } else if (cartItem.properties && cartItem.properties._bottle_image) {
                        imgUrl = cartItem.properties._bottle_image;
                    } else if (cartItem.properties && cartItem.properties['bottle-image']) {
                        // Remove non-private property check after 2024-07-23
                        imgUrl = cartItem.properties['bottle-image'];
                    } else if (cartItem.properties && cartItem.properties._previews) {
                        imgUrl = cartItem.properties._previews;
                    } else {
                        imgUrl = cartItem.image;
                    }

                    // If it's a bundle, prep the details display
                    let variantDetails = '';
                    if (cartItem.properties && cartItem.properties._bundle_variant_details) {
                        const bundleVariantDetails = typeof cartItem.properties._bundle_variant_details === 'string' ?
                            JSON.parse(cartItem.properties._bundle_variant_details) :
                            cartItem.properties._bundle_variant_details
                            ;
                        for (const variantDetail of Object.entries(bundleVariantDetails)) {
                            variantDetails += `<div><strong>${variantDetail[0]}:</strong> ${variantDetail[1]}</div>`;
                        }
                    }

                    if (isBogoBottleDrop){
                        variantDetails += `<div><ul><li>${cartItem.options_with_values[0].value} 42oz. Stainless Steel Bottle & Comfort Grip Lid</li><li>${cartItem.options_with_values[1].value} 42oz. Stainless Steel Bottle & Comfort Grip Lid</li></ul></div>`;
                    }

                    if (isCirkulBackBundle) {
                        _.forEach(cartItem.properties, (value, key) => {
                            if (!_.startsWith(key, '_')) {
                                if (Array.isArray(value)) {
                                    _.forEach(value, (item) => {
                                        variantDetails += `<div><strong>${key}:</strong> ${item}</div>`;
                                    });
                                } else {
                                    // Regular key-value pair
                                    variantDetails += `<div><strong>${key}:</strong> ${value}</div>`;
                                }
                            }
                        });
                    }
                    // Remove non-private property check after 2024-07-23
                    if (cartItem.properties && cartItem.properties.bundle_variant_details) {
                        for (const variantDetail of Object.entries(cartItem.properties.bundle_variant_details)) {
                            variantDetails += `<div><strong>${variantDetail[0]}:</strong> ${variantDetail[1]}</div>`;
                        }
                    }

                    if (_.includes(NOT_DISCOUNTABLE_TITLES, cartItem.product_title) || _.includes(NOT_DISCOUNTABLE_PRODUCT_TYPES, cartItem.product_type) || _.includes(NOT_DISCOUNTABLE_VENDORS, cartItem.vendor)) {
                        variantDetails += `<div><em>Not eligible for bundle discount.</em></div>`;
                    }

                    if (cartItem.vendor === 'Cirkul Variety Packs') {
                        variantDetails += `<div><em>No code needed. One Variety Pack out of four will be free at checkout!</em></div>`;
                    }

                    if (cartItem.properties && cartItem.properties._customization) {
                        variantDetails += `<div><em>Please direct any additional requests or questions regarding your Custom Bottle to our customer service team at <a href="mailto:Help@DrinkCirkul.com" target="_blank">Help@DrinkCirkul.com</a>.</em></div>`;
                    }

                    // Remove some item name prefixes
                    let displayTitle = _.replace(cartItem.product_title, /(?:Starter Kit Extra: |CX: )/g, '');
                    if (cartItem.product_type === 'Subscription') {
                        displayTitle = displayTitle + ' Plan';
                    }

                    console.log(`TJN cartSubtotal`, cartSubtotal, cartSubtotal < 1500, cartSubtotal < 3500);
                    $itemsContainer.append(`
                    <div class="cart-item" 
                            data-cart-item="${getCirkulItemId(cartItem)}" 
                            data-cart-item-type="${cartItem.product_type}" 
                            ${(cartItem.properties && cartItem.properties[FREE_GIFT_MINIMUM_CART_TOTAL_PROPERTY]) ? `data-cart-free-with-minimum-purchase="${(cartItem.properties[FREE_GIFT_MINIMUM_CART_TOTAL_PROPERTY] / 100.0).toFixed(2).replace('.00', '')}"` : ''}
                            ${(cartItem.properties && cartItem.properties[FREE_GIFT_MINIMUM_CART_FULL_PRICE_SIPS_COUNT_PROPERTY]) ? `data-cart-free-with-minimum-full-price-sips="${cartItem.properties[FREE_GIFT_MINIMUM_CART_FULL_PRICE_SIPS_COUNT_PROPERTY]}"` : ''}
                            data-cart-item-sku="${cartItem.sku}"
                    >
                        <div class="cart-item-image">
                            <img src="${imgUrl}" alt="${displayTitle}" />
                        </div>
                        <div class="cart-item-details">
                            <div class="flex align-items-center justify-content-between cart-item-title-container">
                                <span class="cart-item-title">${displayTitle}</span>
                                <button data-cart-item-remove data-cirkul-item-id="${getCirkulItemId(cartItem)}" class="remove-btn">
                                ${!isCXItem && !isTrialKit && !isFreeBottle ? (`<img class="cart-item-remove-icon" src="${$('[data-cart-close-icon]')[0] && $('[data-cart-close-icon]')[0].getAttribute('src')}" alt="Remove" />`) : ''}
                                </button>
                            </div>
                            <div class="cart-variant-details">
                                ${variantDetails}
                            </div>
                            <div class="flex align-items-center justify-content-between">
                                ${(isRewardItem || isCXItem || isPlanPageBottle || isFreeBottle || isTrialKit || isCirkulBackBundle) ?
                            `<span class="cart-item-quantity-noedit">${cartItem.quantity}</span>` :
                            (isPlan) ?
                                `<span></span>` : // intentionally blank
                                (`<input data-cart-item-quantity-input data-cirkul-item-id="${getCirkulItemId(cartItem)}" class="cart-item-quantity-input" type="number" min="1" ${isLimitedItem ? `max="${limitedItemMax}"` : ''} step="1" value="${cartItem.quantity}">`)
                        }

                            ${((isRewardItem || isCXItem || isPlanPageBottle || isTrialKit || isFreeBottle) && cartItem.price === 0) ?
                            `   <strong>FREE</strong>

                                `
                            : `
                            <div data-cart-item-price-container>
                                ${isCartItemDiscountable(cartItem) ? `<div class="cart-item-price" data-cart-item-price="${getCirkulItemId(cartItem)}">$${(cartItem.quantity * cartItem.price * ((100 - currentTier.discount) / 100) / 100).toFixed(2)}</div>` : `<div class="cart-item-price" data-cart-item-price="${getCirkulItemId(cartItem)}">$${(cartItem.quantity * cartItem.price / 100).toFixed(2)}</div>`}
                                ${(currentTier.discount > 0 && isCartItemDiscountable(cartItem)) ? `<div class="cart-item-price strikethrough data-cart-item-price="${getCirkulItemId(cartItem)}">$${(cartItem.quantity * cartItem.price / 100).toFixed(2)}</div>` : ''}
                            </div>
                            `
                        }
                            



                            </div>
                        </div>
                    </div>
                `);
                }
            }

            // Handle Removals
            $('[data-cart-item]').each(function () {
                const cirkulItemId = $(this).attr('data-cart-item');

                if (!cartItems[cirkulItemId]) {
                    $(this).remove();
                }
            });

            $('[data-cart-free-with-minimum-purchase]').each((index, element) => {
                const $cartItem = $(element);
                const minimumPurchaseAmount = parseInt(($cartItem.data('cart-free-with-minimum-purchase') || 0) * 100);

                $cartItem.toggleClass('disabled', minimumPurchaseAmount && cartSubtotal < minimumPurchaseAmount);
            });

            $('[data-cart-free-with-minimum-full-price-sips]').each((index, element) => {
                const $cartItem = $(element);
                const minimumFullPriceSipsCount = parseInt($cartItem.data('cart-free-with-minimum-full-price-sips') || 0);

                $cartItem.toggleClass('disabled', minimumFullPriceSipsCount && cartFullPriceSipsCount < minimumFullPriceSipsCount);
            });
        }

        function _renderCartTotals() {
            // UPDATE THE ITEM COUNT
            if(itemCount >= 1){
                $('[data-cart-item-count]').show();
                $('[data-cart-item-count]').text(itemCount);
            } else{
                $('[data-cart-item-count]').hide();
            }

            $('[data-cart-icon-with-count]').attr('aria-label', `Show Cart - ${itemCount} items in cart`);

            // RENDER TOTALS ON STEP 1
            const $cartTotal = $('[data-cart-total]');
            const $cartSubtotal = $('[data-cart-subtotal]');
            const $discountTotal = $('[data-cart-discount]');
            $cartTotal.html(`$${(cartTotal / 100).toFixed(2)}`);
            $cartSubtotal.html(`$${(cartSubtotal / 100).toFixed(2)}`);
            $discountTotal.html(`$${(discountTotal / 100).toFixed(2)}`);

            // RENDER TOTALS ON STEP 2
            selectedPlan = $('[type="radio"][name="bundleTypeAndPlan"]:checked').val();
            const $cartPlanTotal = $('[data-cart-plan-total]');
            const $cartAutoshipLine = $('[data-cart-autoship-line]');
            const $cartAutoshipTotal = $('[data-cart-autoship-total]');
            const $step2Subtotal = $('[data-cart-step="2"] [data-cart-subtotal]');

            // Get the price for a plan (or set to null if one-time)
            cartAutoshipTotal = subscriptionPresets[selectedPlan] ? subscriptionPresets[selectedPlan].product.price : null;

            // If a plan is selected...
            if (cartAutoshipTotal) {
                cartPlanTotal = cartSubtotal - (discountableSubtotal * ((currentTier.discount + DISCOUNTS.autoshipDiscount) / 100));
                $cartAutoshipTotal.html(`$${cartAutoshipTotal}`);
                $cartAutoshipLine.removeClass('hide');
            } else {
                cartPlanTotal = cartTotal;
                $cartAutoshipTotal.html("");
                $cartAutoshipLine.addClass('hide');
            }

            // If there's no discount whatsoever, hide the strikethrough amount...
            if (cartPlanTotal === cartSubtotal) {
                $step2Subtotal.addClass('hide');
            } else {
                $step2Subtotal.removeClass('hide');
            }

            // Disable CTA if no items in cart...
            const $cartCTA = $('[data-cart-cta], [data-bb-next]');
            if (itemCount > offerItemCount) {
                $cartCTA.removeAttr('disabled');
            } else {
                $cartCTA.attr('disabled', 'true');
            }

            $cartPlanTotal.html(`$${(cartPlanTotal / 100).toFixed(2)}`);
        }

        function _renderTierDiscounts() {
            recalculateCartSubtotal();

            const $tiersContainer = $('[data-cart-discount-tracker]');
            $tiersContainer.empty();

            for (const [i, tier] of DISCOUNTS.tiers.entries()) {
                $tiersContainer.append(`<div class="cart-discount-tier" data-cart-discount-tier="${i + 1}"><span class="tier-percentage">${tier.discount}%</span> Off</div>`);
            }

            const $bundleDiscountTiers = $('[data-cart-discount-tier]'); // needs to be local?

            $bundleDiscountTiers.each((index, element) => {
                const $discountTier = $(element);
                const tierNumber = parseInt($discountTier.data('cart-discount-tier'));
                if (currentTier) {
                    $discountTier.toggleClass(TIER_REACHED_CLASS, tierNumber <= currentTier.tierNumber);
                    $discountTier.toggleClass(NEXT_TIER_CLASS, tierNumber === currentTier.tierNumber + 1);
                }
            });

            if (alreadySubscriber) {
                $('[data-save-more]').addClass('hide');
            } else {
                $('[data-save-more]').removeClass('hide');
            }
        }

        function _renderAlerts() {
            if (!firstRender && !suppressAlerts) {
                // console.log(DISCOUNTS);

                if (currentTier.tierNumber > 0 && currentTier.tierAlertShown === false) {
                    const tierAlert = `Congrats! You've reached ${currentTier.discount}% off your order`;
                    currentTier.tierAlertShown = true;
                    window.toastr.success(tierAlert, null, { positionClass: 'toast-top-center' });
                } else {
                    if (alertMsg.length) {
                        window.toastr.success(alertMsg, null, { positionClass: 'toast-top-center' });
                    }
                }
            }

            alertMsg = '';
        }

        function _renderTierDiscountMessage() {
            let currentBundleTierMessage;
            const $discountTierMessage = $('[data-cart-discount-tier-message]');

            // $bundleDiscountPercent.html(currentDiscount ? `${currentDiscount}%` : `N/A`);
            // currentBundleTotal = currentBundleSubtotal * (100 - currentDiscount) / 100;
            if (amountToNextTier > 0) {
                currentBundleTierMessage = `Spend $${(amountToNextTier / 100).toFixed(2)} more to unlock ${nextTier.discount}% off!`;
            } else {
                currentBundleTierMessage = `You unlocked ${currentTier.discount}% off!`;
            }

            $discountTierMessage.html(currentBundleTierMessage);
            $discountTierMessage.data('cart-discount-tier-percent', currentTier.discount);
        }

        function _syncOnPageQuantityControls() {
            const $allQuantityControls = $(`[data-grid-product-quantity-controls]`);

            $allQuantityControls.each((index, element) => {
                const $quantityControls = $(element);
                const variantId = $quantityControls.data('grid-product-quantity-controls');
                const $decrementButton = $quantityControls.find('[data-grid-product-quantity-decrement]');
                const $quantitySpan = $quantityControls.find('[data-grid-product-quantity-display]');
                let currentQty = 0;

                // Sometimes the same variant is split across multiple lines because of discounting
                _.forEach(cartItems, (cartItem) => {
                    if (cartItem.id === variantId) {
                        currentQty += cartItem.quantity;
                    }
                });

                $quantitySpan.attr('data-grid-product-quantity-display', currentQty);
                $quantitySpan.text(currentQty);
                
                //Dispatch event to update item count in DirectAddToCart (DirectAddToCart.js)
                const cartItemUpdatedEvent = new CustomEvent('cirkul:cart:item-updated', { detail: { variantId, currentQty } });
                document.dispatchEvent(cartItemUpdatedEvent);

                $decrementButton.toggleClass('hide', currentQty < 1);
                $quantitySpan.toggleClass('hide', currentQty < 1);
            });
        }

        function _syncModalSipsInCartCounts() {
            const $allCounts = $('[data-modal-sips-in-cart]');

            $allCounts.each((idx, el) => {
                const variantId = $(el).data('modal-sips-in-cart');
                const currentQty = cartItems?.[variantId]?.quantity || 0;
                $(el).text(currentQty);
                $(el).toggleClass('hide', currentQty < 1);
            });
        }
    }

    function addTikTokClickId() {
        return new Promise((resolve, reject) => {

            const ttclid = localStorage.getItem('cirkul-ttclid');

            // console.log(`ttclid in cart`, ttclid);

            if (ttclid) {
                $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    dataType: 'json',
                    data: {
                        attributes: {
                            '__ttclid': ttclid,
                        }
                    },
                    success: resolve,
                    error: (err) => {
                        console.error(err);
                        resolve(); // Error here shouldn't stop customer from progressing
                    },
                });
            } else {
                resolve();
            }
        });
    }

    // WHEN CHANING AN ITEM QUANTITY
    $(document).on('input paste', '[data-cart-item-quantity-input]', (event) => {
        const $quantityInput = $(event.currentTarget);
        const quantityMax = $quantityInput.prop('max');
        let newQty = $quantityInput.val() || 0;

        if (quantityMax) {
            newQty = Math.min(newQty, quantityMax);
        }

        const cirkulItemId = $(event.currentTarget).data('cirkul-item-id').toString();

        if (newQty === 0) {
            return; // customer may be adjusting. To remove, they can use the remove button.
        }

        updateCartItem(cirkulItemId, parseInt(newQty));
        renderCart();
    });

    // WHEN REMOVING AN ITEM
    $(document).on('click', '[data-cart-item-remove]', (event) => {
        const $removeButton = $(event.currentTarget);
        const cirkulItemId = $removeButton.data('cirkul-item-id').toString();
        const itemType = $removeButton.closest('[data-cart-item-type]').data('cart-item-type');

        // Immediately update and render *this* item...
        updateCartItem(cirkulItemId, 0);
        renderCart();

        // ... then, if we removed a Subscription Plan, remove ALL subscription and trial-related items and re-render again
        if (itemType === 'Subscription') {
            Promise.resolve()
                .then(removeAllSubscriptionAndTrialItems)
                .then(getCart)
                .then(renderCart)
                ;
        }
    });

    // WHEN CLICKING ON CART CTA
    let cartCtaClickProcessing = false; // prevents multi-clicking from adding duplicate subscription items to cart.
    $(document).on('click', '[data-cart-cta]', (event) => {
        if (cartCtaClickProcessing) return;

        cartCtaClickProcessing = true;

        const cartNextEnabled = !$('[data-cart-cta]').attr('disabled');

        if (cartNextEnabled && (itemCount > offerItemCount)) {
            if (cartStep === 1 && !alreadySubscriber && !oldPlanInCart) {
                recalculateSpecialCartItems();
                _renderBottleWarning();
                _renderFreeItemWarning();
                cartStep = 2;

                $(`[data-cart-step]`).toggleClass("hide");
                cartCtaClickProcessing = false;
            } else if (alreadySubscriber) {
                window.location.href = '/checkout';
            } else if (oldPlanInCart) {
                // Just removes *NEW* subscription items... the old plan stays in there...
                removeSubscriptionPlaceholderItems()
                    .then(() => {
                        window.location.href = '/checkout';
                    });
            } else {
                // DETERMINE CORRECT CHECKOUT & GO...
                if (selectedPlan && selectedPlan !== 'one-time') {
                    removeSubscriptionPlaceholderItems()
                        .then(addSubscriptionItems)
                        .then(() => {
                            window.location.href = '/checkout';
                        });
                } else {
                    removeSubscriptionPlaceholderItems()
                        .then(() => {
                            window.location.href = '/checkout';
                        });
                }
            }
        }

        function _renderBottleWarning() {
            const $bottleWarning = $('#no-bottle-warning');

            if (!$bottleWarning.length) {
                return;
            }

            if (cartStep === 1 && !alreadySubscriber && !ignoredBottleWarning && bottlesInCart < 1) {
                console.log("BOTTLE WARNING!");
                $bottleWarning.foundation('open');
            } else {
                $bottleWarning.foundation('close');
            }

        }

        function _renderFreeItemWarning() {
            const minimumThreshold = 3500;
            const $freeItemWarning = $('[data-free-item-warning]');

            console.log("TJN, _renderFreeItemWarning", ignoredBottleWarning, !$freeItemWarning.length);

            if (ignoredBottleWarning || !$freeItemWarning.length) {
                return;
            }

            let shouldShowModal = false;
            let modalType = '';
            // let sipThreshold = 0;

            $('[data-cart-free-with-minimum-purchase]').each((index, element) => {
                const $cartItem = $(element);
                const itemSku = $cartItem.data('cart-item-sku');
                const isDisabled = $cartItem.hasClass('disabled');

                console.log(`TJN itemSku`, itemSku, itemSku === FREE_WHITE_BOTTLE_SKU);

                if (itemSku === FREE_WHITE_BOTTLE_SKU && isDisabled) {
                    shouldShowModal = true;
                    modalType = 'minimum-purchase';
                }
            });

            $('[data-cart-free-with-minimum-full-price-sips]').each((index, element) => {
                const $cartItem = $(element);
                const itemSku = $cartItem.data('cart-item-sku');
                const isDisabled = $cartItem.hasClass('disabled');

                console.log(`TJN itemSku`, itemSku, itemSku === FREE_WHITE_BOTTLE_SKU);

                if (itemSku === FREE_WHITE_BOTTLE_SKU && isDisabled) {
                    shouldShowModal = true;
                    modalType = 'minimum-sips';
                    // sipThreshold = $(element).data('cart-free-with-minimum-full-price-sips');
                }
            });

            if (shouldShowModal && modalType === 'minimum-purchase') {
                const amountLeft = ((minimumThreshold - cartSubtotal) / 100).toFixed(2);

                $('[data-amount-left-to-add]').text('$' + amountLeft);
                $('[data-warning-message]').addClass('hide');
                $('[data-warning-message="minimum-purchase"]').removeClass('hide');
                $freeItemWarning.foundation('open');
            } else if (shouldShowModal && modalType === 'minimum-sips') {
                // Tested but never mainstreamed. Leaving here in case we want to.
                // const sipsLeft = sipThreshold - cartFullPriceSipsCount;

                // $('[data-free-sips-to-add]').text(sipsLeft);
                // $('[data-warning-message]').addClass('hide');
                // $('[data-warning-message="minimum-sips"]').removeClass('hide');
                // $freeItemWarning.foundation('open');
            }
        }
    });

    // WHEN CLICKING BACK BUTTON ON STEP 2
    $(document).on('click', '[data-cart-navigate-back]', (event) => {
        cartStep = 1;
        $(`[data-cart-step]`).toggleClass("hide");
    });

    // When changing plans...
    $(document).on('change', '[type="radio"][name="bundleTypeAndPlan"]', (event) => {
        renderCart();
        // updateCartTotals();
    });

    // When opening the cart...
    $(document).on('opened.zf.offcanvas', '#sitewide-cart', function () {
        window.waitForCirkulServices.analyticsTags.then(() => {
            try {
                const AnalayticsTagsService = window.cirkulServices.analyticsTags;
                AnalayticsTagsService.logEvent(AnalayticsTagsService.TAG_EVENTS.VIEWED_CART);
            } catch (err) { } // Failure to log should not prevent actual cart add.
        });

        //Hide chat when cart opens
        $(`#chat-window`).addClass("hide");
        $(`#chat-button`).addClass("hide");
    });

    //Display chat when cart closes
    $(document).on('closed.zf.offcanvas', '#sitewide-cart', function () {
        $(`#chat-window`).removeClass("hide");
        $(`#chat-button`).removeClass("hide");
    });


    // When clicking to ignore the "No Bottle in Cart" Modal warning...
    $(document).on('click', '[data-ignore-bottle-warning]', (event) => {
        ignoredBottleWarning = true;
        $('#no-bottle-warning').foundation('close');
    });

    // When clicking to acknowledge the "No Bottle in Cart" Modal warning...
    // $(document).on('click', '[data-confirm-bottle-warning]', (event) => {
    //     document.getElementById("bottles").scrollIntoView();
    //     $('#no-bottle-warning').foundation('close');
    // });

    $(document).on('click', '[data-confirm-bottle-warning]', (event) => {
        cartStep = 1;
        $(`[data-cart-step]`).toggleClass("hide");
        $('#no-bottle-warning').foundation('close');
        $('[data-sitewide-cart]').foundation('toggle');
        document.getElementById("bottles").scrollIntoView();
    });

    $(document).on('click', '[data-cart-items-expander]', (event) => {
        $('[data-cart-items-expander]').toggleClass('expanded');
        $('[data-cart-items]').toggleClass('hide');
    });

    $(document).on('click', '[data-free-item-warning-ignore]', (event) => {
        ignoredBottleWarning = true;
        $('[data-free-item-warning]').foundation('close');
    });

    $(document).on('click', '[data-free-item-warning-confirm]', (event) => {
        cartStep = 1;
        $('[data-cart-step]').toggleClass('hide');
        $('[data-free-item-warning]').foundation('close');
        $('[data-sitewide-cart]').foundation('toggle');
    });
})();
